import React from 'react';
import './Home.css';
import Me from '../../assets/androgynous-avatar-non-binary-queer-person.jpg';
import HeaderSocials from './HeaderSocials';
import ScrollDown from './ScrollDown';
import Shapes from './Shapes';

const Home = () => {
    return (
        <section className="home container" id='home'>
            <div className="intro">
                <img src={Me} alt="" className='home__img' width='180' />
                <h1 className="home__name">Ayush Singh</h1>
                <span className="home__education">Aspiring Data Scientist</span><br></br>
                <span className="home__education">Full-Stack Developer </span>
                <p>Explore insights through data</p>

                 <HeaderSocials />

                <a href="#contact" className="btn"> Contact Me</a>

                <ScrollDown />
            </div>

            <Shapes />
        </section>
    )
}

export default Home